// extracted by mini-css-extract-plugin
export default {"Background":"background_Background__4fI90","backgroundWrapper":"background_backgroundWrapper__uYSjg"};